<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    person
                </mat-icon>
                <span>
                    Person: {{ itemEnvelope?.Document?.Item?.FirstName }} {{ itemEnvelope?.Document?.Item?.LastName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit Person: {{ itemEnvelope?.Document?.Item?.PersonId }} - {{ itemEnvelope?.Document?.Item?.FirstName }} {{ itemEnvelope?.Document?.Item?.LastName }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <app-image srcPath="{{ avatarUrl }}" isApiImage="true" className="app-image-medium app-image-circle"></app-image>
                        <button *ngIf="itemEnvelope?.ItemId" mat-button class="button-mini button-inconspicuous avatar-button" (click)="editAvatar()">
                            <mat-icon class="material-symbols-outlined">
                                edit
                            </mat-icon>
                            EDIT
                        </button>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <mat-form-field appearance="outline">
                            <mat-label>First Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="FirstName" placeholder="First Name" [(ngModel)]="$any(itemEnvelope).Document.Item.FirstName" />
                        </mat-form-field>
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Last Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="LastName" placeholder="Last Name" [(ngModel)]="$any(itemEnvelope).Document.Item.LastName" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <mat-tab-group>
                <br />
                <mat-tab label="General">
                    <br />
                    <mat-form-field appearance="outline">
                        <mat-label>DOB</mat-label>
                        <input matInput [matDatepicker]="picker" [(ngModel)]="this.itemEnvelope?.Document?.Item.DOB" />
                        <mat-hint>MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </mat-tab>
                <mat-tab label="Organizations">
                    <br />
                    <form>
                        <span>
                            <app-chip-selector #organizationalUnitChipSelector label="Organizations" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableOrganizationalUnits" [value]="selectedOrganizationalUnitIds"></app-chip-selector>
                        </span>
                    </form>
                </mat-tab>
                <mat-tab label="Groups">
                    <br />
                    <form>
                        <span>
                            <app-chip-selector #groupsChipSelector label="Groups" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableGroups" [value]="selectedGroupIds"></app-chip-selector>
                        </span>
                    </form>
                </mat-tab>
                <mat-tab label="Preferences">
                    <br />
                    <app-person-preferences [personEnvelope]="personEnvelope"></app-person-preferences>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>

